export const colors = {
  primary: "#938370",
  primary90: "rgba(147,131,112,0.9)",
  primary80: "rgba(147,131,112,0.8)",
  cta: "#A74C00",
  // Klikbare tekst = merkkleur, gelijk aan colorLink in App.js.
  clickable_text: "#938370",
};
